import {
  Breadcrumbs,
  Button,
  IconButton,
  Link,
  ListItem,
  ListItemIcon,
  TextField,
  Typography,
  withWidth,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import BusinessIcon from "@material-ui/icons/Business";
import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";
import UserIcon from "@material-ui/icons/Person";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ContactSearchAutocomplete from "../../../Components/Contacts/ContactSearchAutocomplete";
import Title from "../../../Components/Title";

import { Delete } from "@material-ui/icons";
import BrowseContactsDialog from "../../../Components/Contacts/BrowseContactsDialog";
import ContactInfoBadge from "../../../Components/Contacts/ContactInfoBadge";
import CountrySearch from "../../../Components/CountrySearch";
import CountryFlag from "../../../Components/CountrySearch/CountryFlag";
import TicketList from "../../../Components/TicketList";
import {
  checkAdmin,
  getToken,
  requestErrorHandler,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";
import DetailTabs from "../../DeviceDetails/DetailTabs";
import DeviceHistory from "./DeviceHistory";
const server = EnvSettings.server;

function ContactTypeView({ id, type, contact, width }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [newCompany, setNewCompany] = useState();
  const [newParent, setNewParent] = useState();
  const [editAdditionalInfo, setEditAdditionalInfo] = useState(false);
  const [editCompanyName, setEditCompanyName] = useState(false);
  const [newAdditionalInfo, setNewAdditionalInfo] = useState();
  const history = useHistory();

  const additionalInfo = [{ name: "contactEmail" }, { name: "contactPhone" }];

  const submitEditCompanyName = () => {
    if (!newCompany || !id) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        contactData: {
          contactName: newCompany,
          contactId: id,
        },
      }),
    };
    fetch(server + "/edit_contact", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
      });
  };

  const editContact = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        contactData: {
          contactId: id,
          ...(newParent ? { parentCompany: newParent } : {}),
          ...(newAdditionalInfo ? { additionalInfo: newAdditionalInfo } : {}),
        },
      }),
    };
    fetch(server + "/edit_contact", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          if (result.company) {
            history.push("/contacts/company/" + result.company.id);
          }
          window.location.reload();
        }
      });
  };

  return (
    <>
      <Grid item xs={12}>
        <Title
          style={editCompanyName ? { textDecoration: "line-through" } : {}}
        >
          {contact.name || "Unnamed Contact"}{" "}
          <IconButton
            onClick={() => {
              if (editCompanyName) {
                setNewCompany();
              }
              setEditCompanyName(!editCompanyName);
            }}
          >
            {!editCompanyName ? <EditIcon /> : <CancelIcon />}
          </IconButton>
        </Title>
        {editCompanyName ? (
          <TextField
            variant="outlined"
            fullWidth
            label={t("contactInfo.contactName")}
            inputProps={{ maxLength: 255 }}
            defaultValue={contact.name}
            onChange={(e) => {
              setNewCompany(e.target.value);
            }}
          />
        ) : null}
        {editCompanyName && newCompany ? (
          <Button
            variant="contained"
            color="primary"
            onClick={submitEditCompanyName}
          >
            {t("submit")}
          </Button>
        ) : null}
      </Grid>
      <Grid item sm={3} xs={12} container spacing={1} alignContent="flex-start">
        <>
          <Grid item xs={12}>
            <Title>
              Info{" "}
              <IconButton
                onClick={() => {
                  if (editAdditionalInfo) {
                    setNewAdditionalInfo();
                  }
                  setEditAdditionalInfo(!editAdditionalInfo);
                }}
              >
                {!editAdditionalInfo ? <EditIcon /> : <CancelIcon />}
              </IconButton>
            </Title>
          </Grid>
          {additionalInfo.map((m, i) => (
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                key={i}
                value={
                  newAdditionalInfo?.[m.name] ||
                  contact.additionalInfo?.[m.name]
                }
                InputLabelProps={{ shrink: true }}
                fullWidth
                label={t("contactInfo." + m.name)}
                multiline={m.multiline}
                rows={m.multiline ? 6 : 1}
                onChange={(e) => {
                  setNewAdditionalInfo({
                    ...(newAdditionalInfo ? newAdditionalInfo : {}),
                    [m.name]: e.target.value,
                  });
                }}
                disabled={!editAdditionalInfo}
              />
            </Grid>
          ))}
          {editAdditionalInfo && newAdditionalInfo ? (
            <Button variant="contained" color="primary" onClick={editContact}>
              {t("submit")}
            </Button>
          ) : null}{" "}
        </>
      </Grid>
      <Grid item sm={3} xs={12}>
        <BrowseContactsDialog
          label={
            (contact.Company ? t("edit") : t("add")) +
            " " +
            t("companyList.company")
          }
          onlyCompanies={true}
          setClientInfoObject={(e, v) => {
            setNewParent(e);
          }}
          activeObject={newParent || contact.Company}
        />
        {newParent || contact.Company ? (
          <Grid container direction="row" style={{ marginTop: 5 }} spacing={1}>
            <Grid item xs={10}>
              <ContactInfoBadge
                clientInfoObject={newParent || contact.Company}
                direction={"row"}
                onClick={() => {
                  history.push(
                    (checkAdmin() && "/cpanel") +
                      "/contacts/company/" +
                      contact.Company.id
                  );
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => {
                  setNewParent();
                }}
              >
                <Delete />
              </IconButton>
            </Grid>
            {newParent && (
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={editContact}
                >
                  {t("submit")}
                </Button>
              </Grid>
            )}
          </Grid>
        ) : null}
      </Grid>
    </>
  );
}

function CompanyTypeView({ type, id, contact, width }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [newCompany, setNewCompany] = useState();
  const [newLocation, setNewLocation] = useState();
  const [newContact, setNewContact] = useState();
  const [editLocation, setEditLocation] = useState(false);
  const [newParent, setNewParent] = useState();
  const [addParent, setAddParent] = useState(false);
  const [addContacts, setAddContacts] = useState(false);
  const [newClient, setNewClient] = useState();
  const [editAdditionalInfo, setEditAdditionalInfo] = useState(false);
  const [editCompanyName, setEditCompanyName] = useState(false);
  const [newAdditionalInfo, setNewAdditionalInfo] = useState();
  const history = useHistory();

  const additionalInfo = [
    { name: "companyAddress", multiline: true },
    { name: "companyVatId" },
  ];

  const submitEditCompanyName = () => {
    if (type !== "company" || newCompany === "" || !id) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        contactData: {
          companyName: newCompany,
          companyId: id,
        },
      }),
    };
    fetch(server + "/edit_contact", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
      });
  };

  const editContact = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        contactData: {
          ...(type === "company"
            ? { companyName: contact.name }
            : { contactId: id }),
          ...(newLocation ? { location: newLocation } : {}),
          ...(newCompany ? { companyName: newCompany } : {}),
          ...(newContact ? { contactName: newContact } : {}),
          ...(newParent ? { parentCompany: newParent } : {}),
          ...(newAdditionalInfo ? { additionalInfo: newAdditionalInfo } : {}),
        },
      }),
    };
    fetch(server + "/edit_contact", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          if (result.company) {
            history.push("/contacts/company/" + result.company.id);
          }
          window.location.reload();
        }
      });
  };

  const editClient = () => {
    if (!newClient) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        contactData: {
          ...newClient,
          parentCompany: { companyId: id },
        },
      }),
    };
    fetch(server + "/edit_contact", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
      });
  };

  return (
    <>
      <Grid item xs={12}>
        <Title
          style={editCompanyName ? { textDecoration: "line-through" } : {}}
        >
          {contact.name}{" "}
          {type === "company" ? (
            <IconButton
              onClick={() => {
                if (editCompanyName) {
                  setNewCompany();
                }
                setEditCompanyName(!editCompanyName);
              }}
            >
              {!editCompanyName ? <EditIcon /> : <CancelIcon />}
            </IconButton>
          ) : null}
        </Title>
        {editCompanyName ? (
          <TextField
            variant="outlined"
            fullWidth
            label={t("contactInfo.companyName")}
            inputProps={{ maxLength: 255 }}
            defaultValue={contact.name}
            onChange={(e) => {
              setNewCompany(e.target.value);
            }}
          />
        ) : null}
        {editCompanyName && newCompany ? (
          <Button
            variant="contained"
            color="primary"
            onClick={submitEditCompanyName}
          >
            {t("submit")}
          </Button>
        ) : null}
      </Grid>
      <Grid item sm={3} xs={12} container spacing={1} alignContent="flex-start">
        <Grid item xs={12}>
          <Title>
            Info{" "}
            <IconButton
              onClick={() => {
                if (editAdditionalInfo) {
                  setNewAdditionalInfo();
                  setNewLocation();
                }
                setEditLocation(!editLocation);
                setEditAdditionalInfo(!editAdditionalInfo);
              }}
            >
              {!editAdditionalInfo ? <EditIcon /> : <CancelIcon />}
            </IconButton>
          </Title>
        </Grid>
        <Grid item xs={12}>
          <TextField
            label={t("country")}
            value={contact.location || ""}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            disabled
          ></TextField>
          <IconButton>
            <CountryFlag country_name={contact.location} />
          </IconButton>
        </Grid>
        {editLocation ? (
          <CountrySearch
            onChange={(e, v) => {
              if (v) {
                setNewLocation(v.country);
              } else {
                setNewLocation();
              }
            }}
          />
        ) : null}
        {additionalInfo.map((m, i) => (
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              key={i}
              InputLabelProps={{ shrink: true }}
              value={
                newAdditionalInfo?.[m.name] || contact.additionalInfo?.[m.name]
              }
              fullWidth
              label={t("contactInfo." + m.name)}
              multiline={m.multiline}
              rows={m.multiline ? 6 : 1}
              onChange={(e) => {
                setNewAdditionalInfo({
                  ...(newAdditionalInfo ? newAdditionalInfo : {}),
                  [m.name]: e.target.value,
                });
              }}
              disabled={!editAdditionalInfo}
              style={{ marginBottom: 5 }}
            />
          </Grid>
        ))}
        {(editAdditionalInfo && newAdditionalInfo) || newLocation ? (
          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={editContact}>
              {t("submit")}
            </Button>
          </Grid>
        ) : null}{" "}
      </Grid>
      {contact.Contacts ? (
        <>
          <Grid item sm={3} xs={12} spacing={1}>
            <Title>{t("contactInfo.contacts")}</Title>
            {contact.Contacts.map((c, i) => (
              <ListItem
                key={i}
                button
                onClick={() => {
                  history.push(
                    (checkAdmin() ? "/cpanel" : "") +
                      "/contacts/contact/" +
                      c.id
                  );
                }}
              >
                <ListItemIcon>
                  <UserIcon />
                </ListItemIcon>{" "}
                {c.name}
              </ListItem>
            ))}
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label={t("contactInfo.addContact")}
                size="small"
                onChange={(e) => {
                  setNewContact(e.target.value);
                }}
              ></TextField>
              {newContact ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={editContact}
                >
                  {t("submit")}
                </Button>
              ) : null}
            </Grid>
          </Grid>
          <Grid item sm={3} xs={12} spacing={1}>
            {contact.Parent || addParent ? (
              <Title>{t("contactInfo.parentCompany")}</Title>
            ) : null}
            {contact.Parent ? (
              <Grid item xs={12} container alignItems="center">
                <BusinessIcon style={{ marginRight: 20 }} />
                <Link
                  href={
                    (checkAdmin() ? "/cpanel" : "") +
                    "/contacts/company/" +
                    contact.Parent.id
                  }
                  style={{ fontSize: 20 }}
                >
                  {contact.Parent.name}
                </Link>
              </Grid>
            ) : addParent ? (
              <>
                <Grid item xs={12}>
                  <Typography>{t("contactInfo.addParent")}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <ContactSearchAutocomplete
                    onlyCompanies={true}
                    noDescriptionText={true}
                    onChange={(e, v) => {
                      if (v) {
                        setNewParent(v);
                      } else {
                        setNewParent();
                      }
                    }}
                  />
                  {newParent ? (
                    <>
                      <Typography>{newParent.companyName}</Typography>
                      <Button variant="outlined" onClick={editContact}>
                        {t("submit")}
                      </Button>
                    </>
                  ) : null}
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setAddParent(true);
                  }}
                >
                  {t("contactInfo.contactThroughReseller")}
                </Button>
              </Grid>
            )}
          </Grid>
          <Grid item sm={3} xs={12} container spacing={1}>
            {(contact.EndCustomer && contact.EndCustomer.length) ||
            addContacts ? (
              <>
                <Grid item xs={12}>
                  <Title>{t("contactInfo.resellerClients")}</Title>
                </Grid>
                <Grid item xs={12} container>
                  {contact.EndCustomer
                    ? contact.EndCustomer.map((ec, i) => (
                        <Grid
                          key={i}
                          item
                          xs={12}
                          container
                          alignItems="center"
                        >
                          <BusinessIcon style={{ marginRight: 20 }} />
                          <Link
                            style={{ fontSize: 20 }}
                            href={
                              (checkAdmin() ? "/cpanel" : "") +
                              "/contacts/company/" +
                              ec.id
                            }
                          >
                            {ec.name}
                          </Link>
                        </Grid>
                      ))
                    : null}
                </Grid>

                <Grid item xs={12}>
                  <Typography>{t("contactInfo.addResellerClient")}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <ContactSearchAutocomplete
                    onlyCompanies={true}
                    noDescriptionText={true}
                    onChange={(e, v) => {
                      if (v) {
                        setNewClient(v);
                      } else {
                        setNewClient();
                      }
                    }}
                  />
                </Grid>
                {newClient ? (
                  <Button variant="outlined" onClick={editClient}>
                    {t("submit")}
                  </Button>
                ) : null}
              </>
            ) : (
              <Grid item xs={12}>
                <Button
                  onClick={() => {
                    setAddContacts(true);
                  }}
                  variant="outlined"
                >
                  {t("contactInfo.resellerCompany")}
                </Button>
              </Grid>
            )}
          </Grid>
        </>
      ) : (
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            label={t("contactInfo.addCompany")}
            size="small"
            onChange={(e) => {
              setNewCompany(e.target.value);
              if (!e.target.value) {
                setNewLocation();
              }
            }}
          />
          {newCompany ? (
            <TextField
              variant="outlined"
              label={t("contactInfo.addLocation")}
              size="small"
              onChange={(e) => {
                setNewLocation(e.target.value);
              }}
            />
          ) : null}
        </Grid>
      )}
    </>
  );
}

function Contact({ computedMatch, width }) {
  const { type, id } = computedMatch.params;
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const history = useHistory();

  const getContact = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        contactType: type,
        contactId: id,
      }),
    };
    fetch(server + "/get_contact", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setContact(result.contact);
        }
      });
  };

  useEffect(() => {
    if (type && id) {
      getContact();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id]);

  return contact ? (
    <Paper className={classes.paper}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              color="inherit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push(checkAdmin() ? "/cpanel/contacts" : "/contacts");
              }}
            >
              {t("mainSideBar.contacts")}
            </Link>
            <Typography color="textPrimary">
              {contact.name || id || "Unnamed contact"}
            </Typography>
          </Breadcrumbs>
        </Grid>
        {type === "company" ? (
          <CompanyTypeView
            type={type}
            id={id}
            width={width}
            contact={contact}
          />
        ) : (
          <ContactTypeView
            type={type}
            id={id}
            width={width}
            contact={contact}
          />
        )}
        <Grid item xs={12}>
          <DetailTabs
            activeTabs={[
              {
                label: t("devices.header"),
                content: <DeviceHistory data={contact} width={width} />,
              },
              {
                label: t("deviceDetails.maintenanceTickets"),
                content: (
                  <TicketList
                    parent={
                      type === "company" ? { CompanyId: id } : { ContactId: id }
                    }
                  />
                ),
              },
            ]}
          ></DetailTabs>
        </Grid>
      </Grid>
    </Paper>
  ) : null;
}

export default withWidth()(Contact);
